import * as React from 'react';

function SvgLockClosed(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M16.65 9.333h-.667V6a4 4 0 10-8 0v3.333h-.666A2.67 2.67 0 004.65 12v7.333A2.67 2.67 0 007.317 22h9.333a2.67 2.67 0 002.667-2.667V12a2.67 2.67 0 00-2.667-2.667zm-2 0H9.317V6a2.667 2.667 0 015.333 0v3.333z" })));
}

export default SvgLockClosed;
